export const blockIconsTextformattingCloudUploadNew = (
	<span className='material-symbols-outlined'>cloud_upload</span>
);
